/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TuberculosisHistoryDtoPreviousTherapy =
  (typeof TuberculosisHistoryDtoPreviousTherapy)[keyof typeof TuberculosisHistoryDtoPreviousTherapy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TuberculosisHistoryDtoPreviousTherapy = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
} as const;
